/**
 * Utility to extract the oldest year from a paginated/sorted data array.
 * Assumes the data is sorted by `createdAt` ascending, so the first record is the oldest.
 *
 * @param items Array of data objects containing a `createdAt` string
 * @returns The year of the oldest record, defaulting to 4 years ago.
 */
export function getOldestYearFromData(items?: { createdAt?: string | null }[] | null): number {
    const fallbackYear = new Date().getFullYear() - 4;
    if (!items?.length) return fallbackYear;

    const first = items[0];
    const raw = first.createdAt;
    if (!raw) return fallbackYear;

    const year = new Date(raw).getFullYear();
    return isNaN(year) ? fallbackYear : year;
}
